<template>
    <div class="row">
        <div class="col-12">
            <button
                type="button"
                class="btn btn-primary float-right"
                @click="createUser"
            >
                {{ $t('create') }}
            </button>

            <h1>{{ $t("create-user") }}</h1>

            <!-- Profile -->
            <ProfileEditor :user="user" :validate="validate" class="mt-4" />

            <!-- Requires Activation? -->
            <CheckboxInput label="Requires Activation" v-model="requiresActivation" class="mt-5">
                <template v-slot:label><span class="font-weight-bold">{{  $t('requires-activation') }}</span></template>
                <template v-slot:footer>
                    <div>{{  $t('requires-activation-description') }}</div>
                </template>
            </CheckboxInput>

            <CheckboxInput v-show="requiresActivation" :label="$t('send-activation-email')" v-model="sendActivationEmail">
                <template v-slot:label><span class="font-weight-bold">{{ $t('send-activation-email') }}</span></template>
                <template v-slot:footer>
                    <div>{{  $t('send-activation-email-description') }}</div>
                </template>
            </CheckboxInput>

            <!-- Password -->
            <div v-show="!requiresActivation">
                <div v-if="validate && user.new_password !== user.confirm_new_password" class="alert alert-danger">
                    {{ $t('password-and-confirm-not-equal') }}
                </div>
                <div v-else-if="validate && user.new_password && user.new_password.length < 8" class="alert alert-danger">
                    {{ $t('password-too-short') }}
                </div>

                <TextInput
                    v-model="user.new_password"
                    :label="$t('new-password')"
                    :error="validate && (!user.new_password || (!user.new_password !== !user.confirm_new_password))"
                    :hideText="true"
                />

                <TextInput
                    v-model="user.confirm_new_password"
                    :label="$t('confirm-new-password')"
                    :error="validate && !user.confirm_new_password"
                    :hideText="true"
                />
            </div>

            <!-- Roles -->
            <RolesEditor :user="user" :roles="roles" class="mt-5"/>

            <div v-if="errors" class="alert alert-danger mb-3">{{ $t('some-fields-are-invalid') }}</div>
            <button type="button" class="btn btn-primary" @click="createUser">{{  $t('create') }}</button>
        </div>
    </div>
</template>

<script>
import ProfileEditor from 'src/components/Users/ProfileEditor.vue';
import RolesEditor from 'src/components/Users/RolesEditor.vue';

export default {
    data() {
        return {
            user: {
                roles: []
            },
            roles: [],
            years: {},
            requiresActivation: true,
            sendActivationEmail: true,
            validate: false,
            errors: false,
        }
    },
    mounted() {
        this.allRoles()
    },
    watch: {
    	user: {
			handler(){
				this.$emit('dataChanged', true);
			},
			deep: true
    	}
    },
    methods: {
    	setDefaults() {
    		this.validate = false;
    		this.errors = false;
            this.user = {
                roles: []
            };
    	},
        async createUser() {
            this.validate = true
            this.errors = false

            if (!this.user.first_name) this.errors = true
            if (!this.user.last_name) this.errors = true
            if (!this.user.email) this.errors = true
            if (!this.user.username) this.errors = true

            if (!this.requiresActivation) {
                if (!this.user.new_password) this.errors = true
                else if (this.user.new_password.length < 8) this.errors = true

                if (!this.user.confirm_new_password) this.errors = true
                if (this.user.new_password !== this.user.confirm_new_password ) this.errors = true
            }

            if (this.errors) return

            try {
                this.$store.commit('showBlockingSpinner')

                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/users/create`, {
                    method: 'post',
                    data: {
                        ...this.user,
                        roles: JSON.stringify(this.user.roles),
                        user_username: this.user.username,
                        requiresActivation: this.requiresActivation,
                        sendActivationEmail: this.sendActivationEmail
                    }
                })

                if (res.status === 'SUCCESS') {
                	// Take the "create" vue out of the history
                	this.$router.replace(`/settings/users/update/${res.user.id}`)
                    return
                }

                if (res.errorType === 'ERROR_USERNAME_IN_USE') {
                    this.$store.commit("openDialog", {
                        title: this.$t("username-taken"),
                        content: this.$t('sorry-username-in-use'),
                        confirmCallBack: function () {}
                    })
                } else if (res.errorType === 'ERROR_EMAIL_IN_USE') {
                    this.$store.commit("openDialog", {
                        title: this.$t("email-taken"),
                        content: this.$t('sorry-account-exists-for-email'),
                        confirmCallBack: function () {}
                    })
                } else {
                    this.$store.commit("openDialog", {
                        title: this.$t("something-went-wrong"),
                        content: this.$t('user-create-failed'),
                        confirmCallBack: function () {}
                    })
                }

            } catch (err) {
                this.$log.error.call(this, err)
            } finally {
                this.$store.commit('hideBlockingSpinner')
            }
        },
        async allRoles() {
            try {
                this.$store.commit('showBlockingSpinner')

                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/roles/all`, {
                    method: 'get'
                })

                if (res.status !== 'SUCCESS') return;

                this.roles = res.roles;
            }
            catch (err) {
                this.$log.error.call(this, err)
            }
            finally {
                this.$store.commit('hideBlockingSpinner')
            }
        },
    },
    components: { ProfileEditor, RolesEditor }
}
</script>
